import { Box } from '@chakra-ui/react';
import './style.css';

interface Props {}
export default function ComposerPage(props: Props) {
    return (
        <Box>
            <div className="test">Composer Page</div>
        </Box>
    );
}
